import { connect } from 'react-redux';

import StoryCardV2 from 'components/CollectionParentStoryCardV2';
import { COLLECTION_STORY_CARDS_TARGETING } from 'constants/collection';
import { CAMPAIGN_NAMES } from 'constants/personalizations';
import StoryCardV2Model from 'models/StoryCardV2';
import * as actions from 'state/actions';
import { getStoryCardData } from 'state/selectors/collection';
import PersonalizationsSelector from 'state/selectors/personalizations';

const mapStateToProps = (state, { storyId }) => {
  const storyData = getStoryCardData(state, storyId);
  const variationData = PersonalizationsSelector.getCampaignVariationData(
    state,
    CAMPAIGN_NAMES.MULTI_TOUCH_CAMPAIGN
  );

  if (!storyData) {
    throw new Error(`Could not find story with id "${storyId}"`);
  }

  const story = new StoryCardV2Model(storyData);

  const dyCampaignData =
    story.targeting === COLLECTION_STORY_CARDS_TARGETING.DYNAMIC_YIELD
      ? {
          decisionId: variationData?.decisionId,
          variationId: variationData?.analyticsMetadata?.variationId,
          variationName: variationData?.analyticsMetadata?.variationName,
          experienceName: variationData?.analyticsMetadata?.experienceName,
          campaignName: variationData?.analyticsMetadata?.campaignName,
        }
      : null;

  return {
    backgroundColor: story.backgroundColor,
    ctaLinks: story.ctaLinks,
    desktopImage: story.desktopImage,
    dyCampaignData,
    internalName: story.internalName,
    gradientEnabled: story.gradientEnabled,
    headerEyebrow: story.headerEyebrow,
    heading: story.heading,
    mobileImage: story.mobileImage,
    subheader: story.subheader,
  };
};

const mapDispatchToProps = dispatch => ({
  trackCtaLinkClick: ({
    type,
    location,
    name,
    value,
    url,
    campaignName,
    variationId,
    variationName,
    experienceName,
    decisionId,
  }) => {
    dispatch(
      actions.trackStoryCardCtaLinkClick({
        type,
        location,
        name,
        value,
        url,
        campaignName,
        variationId,
        variationName,
        experienceName,
      })
    );

    dispatch(
      actions.trackEngagementClick({
        dyDecisionId: decisionId,
        dyVariationId: variationId,
      })
    );

    // Because this function will be added to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(StoryCardV2);
